/**
 * Created by PuTi(编程即菩提) 9/1/17.
 */
var nb = require('./nb');
var app = require('./app');
console.log('./io/' + process.env.APP_ENV + '/io');
var io = require('./io/' + process.env.APP_ENV + '/io');
var xModel = require('./model/XModel');
console.log('./io/' + process.env.APP_ENV + '/logOut');
var logOut = require('./io/' + process.env.APP_ENV + '/logOut');
console.log('./config/'+ process.env.APP_CONFIG + '.json');
var trace = require('../nb/trace/js/trace');
var config = require('./config/'+ process.env.APP_CONFIG + '.json');
var serverUrl = config.serverUrl;
var WXHelper = require('../nb/wx/js/WXHelper');
module.exports = nb.define({
    parent: app.Model,
    mapping: {
        header: require('./model/header/Header')
    },
    method:{
        init:function () {
            this.set('confirmModal',require('./model/Modal'));
            this.set('footer',require('./model/Footer'));
            var header = this.get('header');
            var self = this;
            nb.model.onChange(nb.opts.clientReady,function(inEvent){
                var token = this.getToken();
                var loginReady = false;
                var share = config.share;
                var signature = share.signature;
                var wxHelper = new WXHelper();
                wxHelper.setShareAppData(share.app);
                wxHelper.getSignature({
                    url: signature.url,
                    cmd: signature.cmd
                });
                if(token && token !== ""){
                    io.setToken(token);
                    loginReady = true;
                }else {
                    if(this._checkPage()){
                        window.location.href = 'login.html';
                    }
                }
                xModel.set('loginReady',loginReady);
                this._timeIn = new Date().getTime();
                trace.setAppId('artw');
                trace.set('url',serverUrl+'/pageview/log.gif?');
                trace.log({
                    apiType:1
                });
                window.onbeforeunload = function() {
                    trace.log({
                        apiType:2,
                        startTime:self._timeIn,
                        endTime:new Date().getTime()
                    });
                };
            },this);
            header.onChange('exit',function () {
                logOut({
                    scope:this,
                    success:function (inResp) {
                        this.clearToken();
                        xModel.set('loginReady',false);
                        // if(this._checkPage()){
                        //     setTimeout(function () {
                                window.location.href = 'login.html';
                        //     },500);
                        // }
                    },
                    error:function (inResp) {
                        var code = inResp.error.code;
                        if(code===401 ||code===403){
                            this.clearToken();
                            xModel.set('loginReady',false);
                            if(this._checkPage()){
                                setTimeout(function () {
                                    window.location.href = 'login.html';
                                },500);
                            }
                        }
                    }
                });
            },this);
        },
        _checkPage:function () {
            return true
        },
        // _checkToken:function (inToken) {
        //     var header = this.get('header');
        //     checkToken({
        //         scope:this,
        //         success:function (inResp) {
        //             var tokenExpire = inResp.tokenExpire;
        //             switch(tokenExpire){
        //                 case 1:
        //                     this.clearToken();
        //                     if(this._checkPage()){
        //                         setTimeout(function () {
        //                             window.location.href = 'login.html';
        //                         },500)
        //                     }
        //                     break;
        //                 case 0:
        //                     header.set('token',inToken,{skipSameValue:false});
        //             }
        //         },
        //         error:function (inResp) {
        //             this.clearToken();
        //             window.location.href = 'login.html';
        //         }
        //     });
        // },
        getToken:function () {
            return $.cookie('ARTW_token');
        },
        clearToken:function () {
             $.cookie('ARTW_token','');
             $.cookie('ARTW_nickname','');
             $.cookie('ARTW_user_mobile','');
             $.cookie('ARTW_user_password','');
             $.cookie('selected_pay_orderId','');
             $.cookie('pay_status_result','');
        }

    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/Model.js
// module id = 30
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32